import moment from 'moment';

/*
  syncDatesAndTime synchronizes updates to a given date range.
  If one of the range invariants are violated (i.e start > end), syncDatesAndTime will adjust the range by preserving the original duration.
*/
export function syncDatesAndTime(startDate: Object, endDate: Object, whichPicker: string) {
  const dateDuration = moment.duration(startDate.diff(endDate));
  if (whichPicker === 'start') {
    if (startDate.isAfter(endDate)) {
      return { start: startDate, end: endDate.add(dateDuration) };
    }
  }
  if (endDate.isBefore(startDate)) {
    return { start: startDate.subtract(dateDuration), end: endDate };
  }
  return { start: startDate, end: endDate };
}

export function setEventDateAndTime(date, time) {
  return moment(date + time, 'YYYYMMDDHH:mm');
}

export function getLocalDateFormat() {
  const locale = window.navigator.userLanguage || window.navigator.language;
  if (!locale) {
    return 'DD/MM/YYYY';
  }
  moment.locale(locale);
  const localeData = moment.localeData();
  const format = localeData.longDateFormat('L');

  return format;
}



// WEBPACK FOOTER //
// ./src/js/libs/Time.js